import React, { useMemo } from 'react';
import { Callout } from 'seagull';
import { getCreditsWarning } from "../../../business-logic/billingLogic";
import { getClientApprovalCalloutText } from "../BillChargeTableItem/BillChargeTableItem.utils";
import { getBillServiceBeforeItsEffectiveDateWarning } from "../BillServiceTableItem/BillServiceTableItem.utils";
import { getIssueDateBeforeRelationshipEffectiveDateWarning } from "../BillClientModal.utils";
import { serviceModel } from "../../../models";
export function BillChargeClientApprovalCallout(_ref) {
  let {
    issueDate,
    invoiceDateInfo
  } = _ref;
  const text = useMemo(() => getClientApprovalCalloutText(issueDate, invoiceDateInfo), [issueDate, invoiceDateInfo]);
  return /*#__PURE__*/React.createElement(Callout, {
    withBorder: true
  }, text);
}
export function ServiceEffectiveDateCallout(_ref2) {
  let {
    mode,
    service,
    issueDate,
    relationshipEffectiveDate,
    testid
  } = _ref2;
  const warning = useMemo(() => getBillServiceBeforeItsEffectiveDateWarning(mode, service, issueDate, relationshipEffectiveDate), [mode, service, issueDate, relationshipEffectiveDate]);
  if (!warning) return null;
  return /*#__PURE__*/React.createElement(Callout, {
    "data-testid": testid,
    withBorder: true
  }, warning.text);
}
export function ServicePendingAmendmentCallout(_ref3) {
  let {
    service,
    testid
  } = _ref3;
  const isPendingOrAmended = serviceModel.isAwaitingApproval(service.status) || serviceModel.isAmended(service.status);
  if (!isPendingOrAmended) return null;
  return /*#__PURE__*/React.createElement(Callout, {
    "data-testid": testid,
    intent: "warning",
    withBorder: true
  }, "As this service is part of a pending amendment, the invoice will require client approval.");
}
export function CreditsWarningCallout(_ref4) {
  let {
    totalCredits,
    testid
  } = _ref4;
  const warning = useMemo(() => getCreditsWarning(totalCredits), [totalCredits]);
  if (!warning) return null;
  return /*#__PURE__*/React.createElement(Callout, {
    "data-testid": testid,
    withBorder: true
  }, warning.text);
}
export function RelationshipEffectiveDateCallout(_ref5) {
  let {
    issueDate,
    effectiveDate,
    testid
  } = _ref5;
  const warning = useMemo(() => getIssueDateBeforeRelationshipEffectiveDateWarning(effectiveDate, issueDate), [issueDate, effectiveDate]);
  if (!warning) return null;
  return /*#__PURE__*/React.createElement(Callout, {
    "data-testid": testid,
    withBorder: true
  }, warning.text);
}